import { render, staticRenderFns } from "./IndexBanner.vue?vue&type=template&id=45073c03&scoped=true&"
import script from "./IndexBanner.vue?vue&type=script&lang=js&"
export * from "./IndexBanner.vue?vue&type=script&lang=js&"
import style0 from "./IndexBanner.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./IndexBanner.vue?vue&type=style&index=1&id=45073c03&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45073c03",
  null
  
)

export default component.exports